import { Node } from 'prosemirror-model';
import { BaseNode } from './base/BaseNode';

export class Image extends BaseNode {
  constructor() {
    super('image');
  }

  get schema() {
    return {
      inline: true,
      attrs: {
        src: { validate: 'string' },
        alt: { default: null, validate: 'string|null' },
        title: { default: null, validate: 'string|null' },
      },
      group: 'inline',
      draggable: true,
      parseDOM: [
        {
          tag: 'img[src]',
          getAttrs(dom: HTMLElement) {
            return {
              src: dom.getAttribute('src'),
              title: dom.getAttribute('title'),
              alt: dom.getAttribute('alt'),
            };
          },
        },
      ],
      toDOM(node: Node) {
        const { src, alt, title } = node.attrs;
        return ['img', { src, alt, title }] as const;
      },
      leafText: (node: Node) =>
        node.attrs.alt || node.attrs.title
          ? `(image: ${node.attrs.alt ?? node.attrs.title})`
          : '(image)',
    };
  }
}
